(function () {
  if (window.__FRNE_CART_UX_FIX__) return;
  window.__FRNE_CART_UX_FIX__ = true;

  var doc = document;
  var body = doc.body;
  var root = doc.documentElement;
  var cartTimer = null;
  var rafId = null;
  var cartCache = { at: 0, json: null, inflight: null };

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  function getCartHost() {
    return qs('[class^="ai-cart-drawer-component-"]') ||
      qs('.ai-cart-drawer-component-fallback') ||
      qs('#CartDrawer') ||
      qs('[data-cart-drawer]') ||
      qs('[data-drawer="cart"]') ||
      qs('.cart-drawer') ||
      qs('.drawer--cart') ||
      qs('.drawer.cart');
  }

  function getCartPanel(host) {
    host = host || getCartHost();
    if (!host) return null;
    return qs('[role="dialog"]', host) || qs('.drawer', host) || qs('.cart-drawer', host) || host;
  }

  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  function isCartOpen(host) {
    host = host || getCartHost();
    if (!host) return false;
    if (host.classList.contains('open') || host.classList.contains('is-open') || host.classList.contains('active')) return true;
    var panel = getCartPanel(host);
    if (!panel) return false;
    var aria = panel.getAttribute('aria-hidden');
    if (aria === 'false') return true;
    return isVisible(panel) && panel.getBoundingClientRect().width > 0;
  }

  function syncOpenState() {
    rafId = null;
    var open = isCartOpen();
    root.classList.toggle('frne-cart-open', open);
    body.classList.toggle('frne-cart-open', open);
  }

  function queueSync() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(syncOpenState);
  }

  function closeCart() {
    var host = getCartHost();
    if (!host) return;
    var closeBtn = qs('[aria-label*="close" i], .drawer-close, .cart-close, [data-close], [data-drawer-close]', host);
    if (closeBtn) {
      closeBtn.click();
    } else {
      host.classList.remove('open', 'is-open', 'active');
      var panel = getCartPanel(host);
      if (panel) panel.setAttribute('aria-hidden', 'true');
      queueSync();
    }
  }

  function markLoading(node, on) {
    if (!node) return;
    node.classList.toggle('frne-cart-loading', !!on);
    if (on) node.setAttribute('aria-busy', 'true');
    else node.removeAttribute('aria-busy');
  }

  function invalidateCartCache() {
    cartCache.at = 0;
    cartCache.json = null;
    cartCache.inflight = null;
  }

  function fetchCart(forceFresh) {
    var now = Date.now();
    if (!forceFresh && cartCache.json && now - cartCache.at < 250) return Promise.resolve(cartCache.json);
    if (!forceFresh && cartCache.inflight) return cartCache.inflight;
    cartCache.inflight = fetch('/cart.js?view=uxfix&ts=' + now, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    }).then(function (json) {
      cartCache.at = Date.now();
      cartCache.json = json;
      cartCache.inflight = null;
      return json;
    }).catch(function (err) {
      cartCache.inflight = null;
      throw err;
    });
    return cartCache.inflight;
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);
    } catch (e) {}
    var currency = 'EUR';
    try {
      currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currency;
    } catch (e2) {}
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (e3) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency;
    }
  }

  function pulseCartCount() {
    qsa('[data-cart-count]').forEach(function (el) {
      el.classList.remove('frne-cart-count-updated');
      void el.offsetWidth;
      el.classList.add('frne-cart-count-updated');
      setTimeout(function () { el.classList.remove('frne-cart-count-updated'); }, 220);
    });
  }

  function syncCartSummary(cart) {
    if (!cart) return;
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = String(cart.item_count || 0);
    });
    qsa('[data-cart-cost]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price || 0);
    });
    var totalPrice = qs('.cart-modal-totalprice span');
    if (totalPrice) totalPrice.textContent = formatMoney(cart.total_price || 0);
    var totalCount = qs('.cart-modal-totalcount span.count');
    if (totalCount) totalCount.textContent = String(cart.item_count || 0);
    pulseCartCount();
    doc.dispatchEvent(new CustomEvent('frne:cart-updated', { detail: cart }));
  }

  function refreshCartSoon(forceFresh) {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetchCart(!!forceFresh).then(syncCartSummary).catch(function () {});
      queueSync();
    }, 140);
  }

  function tryOpenCart(ev) {
    var host = getCartHost();
    if (!host) return;
    if (typeof host.openDrawer === 'function') {
      ev.preventDefault();
      host.openDrawer();
      queueSync();
      refreshCartSoon(false);
      return;
    }
    host.classList.add('open');
    var panel = getCartPanel(host);
    if (panel) panel.setAttribute('aria-hidden', 'false');
    queueSync();
    refreshCartSoon(false);
  }

  doc.addEventListener('click', function (ev) {
    var openBtn = ev.target.closest('[data-open-cart-drawer="true"], .js-header-cart');
    if (openBtn) {
      tryOpenCart(ev);
      return;
    }

    var addBtn = ev.target.closest('form[action^="/cart/add"] [type="submit"], form[action^="/cart/add"] button[name="add"], .buy-more-cart, .add-group-to-cart, .buy-together-add-all-to-cart');
    if (addBtn) {
      markLoading(addBtn, true);
      setTimeout(function () { markLoading(addBtn, false); }, 1800);
      invalidateCartCache();
      refreshCartSoon(true);
      return;
    }

    var removeBtn = ev.target.closest('[data-cart-remove], [data-remove], [data-remove-item], .cart-remove, .ajaxcart__qty-remove');
    if (removeBtn) {
      var host = getCartHost();
      if (host) host.classList.add('frne-cart-busy');
      invalidateCartCache();
      setTimeout(function () {
        if (host) host.classList.remove('frne-cart-busy');
      }, 1600);
      refreshCartSoon(true);
    }
  }, true);

  doc.addEventListener('change', function (ev) {
    var qty = ev.target.closest('input[name*="updates"], .ajaxcart__qty-num, [data-quantity] input, .quantity input');
    if (qty) {
      invalidateCartCache();
      refreshCartSoon(true);
    }
  }, true);

  doc.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (form && form.matches('form[action^="/cart/add"]')) {
      var btn = qs('[type="submit"], button[name="add"]', form);
      markLoading(btn, true);
      invalidateCartCache();
      setTimeout(function () {
        markLoading(btn, false);
        refreshCartSoon(true);
      }, 900);
    }
  }, true);

  doc.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && isCartOpen()) closeCart();
  });

  var mo = new MutationObserver(queueSync);
  if (body) mo.observe(body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden'] });

  window.addEventListener('pageshow', function () {
    invalidateCartCache();
    refreshCartSoon(true);
    queueSync();
  });
  window.addEventListener('load', function () {
    refreshCartSoon(false);
    queueSync();
  });
})();
